export default {"src":"/frontend-static/_next/static/media/featured-badge.5d62772b.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};